// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Variant_default_wrapper__3Bhyu","headline":"Variant_default_headline__30p0X","item":"Variant_default_item__3nkYg"};